<template>
	<div>
		<Breadcrumb/>
		<router-view></router-view>
	</div>
</template>

<script>
	import Breadcrumb from '@/components/admin/breadcrumb'
	export default {
		name: 'ActivityIndex',
		components: {
			Breadcrumb
		},
		data() {
			return {
				
			}
		},
		methods: {
	
		}
	}
</script>

<style>
</style>